export const getEmptyTypeaheadSections = ({ emptyTypeahead, productId, previousSearch, sections, }) => {
    if (!emptyTypeahead) {
        return [];
    }
    const { popularSearchSuggestions, previouslySearchedSuggestions, bestSoldProductsSuggestions, relevantProductSuggestions, relevantPageSuggestions, youMayLikeSuggestions, } = sections;
    if (productId) {
        if (!(emptyTypeahead === null || emptyTypeahead === void 0 ? void 0 : emptyTypeahead.relevantPages.length) && !previousSearch.length) {
            return [popularSearchSuggestions, youMayLikeSuggestions, bestSoldProductsSuggestions];
        }
        else if (!(emptyTypeahead === null || emptyTypeahead === void 0 ? void 0 : emptyTypeahead.relevantPages.length)) {
            return [previouslySearchedSuggestions, youMayLikeSuggestions, bestSoldProductsSuggestions];
        }
        return [relevantProductSuggestions, youMayLikeSuggestions, relevantPageSuggestions];
    }
    if (!(emptyTypeahead === null || emptyTypeahead === void 0 ? void 0 : emptyTypeahead.relevantPages.length) && !previousSearch.length) {
        return [popularSearchSuggestions, youMayLikeSuggestions];
    }
    else if (!(emptyTypeahead === null || emptyTypeahead === void 0 ? void 0 : emptyTypeahead.relevantPages.length)) {
        return [previouslySearchedSuggestions, youMayLikeSuggestions];
    }
    else if (!previousSearch.length) {
        return [popularSearchSuggestions, youMayLikeSuggestions, relevantPageSuggestions];
    }
    return [previouslySearchedSuggestions, youMayLikeSuggestions, relevantPageSuggestions];
};
export function stripLanguage(path, language) {
    if (path === `/${language}`) {
        return '/';
    }
    return path.replace(`/${language}/`, '/');
}
//# sourceMappingURL=emptyTypeahead.js.map